export const tableColumns = [
    {
        name: "partPriceId",
        label: "Kode Dokumen",
    },
    {
        name: "mdId",
        label: "Main Dealer",
    },
    {
        name: "effectiveDate",
        label: "Tanggal Berlaku",
    },
    {
        name: "cabangNames",
        label: "Cabang Berlaku",
    },
];

export const formGroup = {
    kodeCabang: { value: "", mandatory: true },
    kodeDocument: { value: "", mandatory: false },
    mdId: { value: "", mandatory: true },
    effectiveDate: { value: "", mandatory: true },
    note: { value: "", mandatory: false },
    masterPartPriceCabang: { value: [] },
    masterPartPriceDetail: {
      value: [
        {
          partCode: { value: "", mandatory: true },
          partPrice: { value: 0, mandatory: true },
        },
      ],
      mandatory: true,
    },
  };
  